import { EmailReq } from '@src/types/emails.ts';

export enum UserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export type TUserTable = {
  id?: string;
  userNumber?: number;
  userName?: string;
  email?: string;
  status?: UserStatus;
};

export enum UserRole {
  ADMIN = 'admin',
  USER = 'user',
  SUPPORT_ENTRY = 'support_entry',
  SUPPORT_JUNIOR = 'support_junior',
  SUPPORT_SENIOR = 'support_senior',
  MARKETING_CONTENT = 'marketing_content',
  MARKETING_DATA = 'marketing_data',
}

export enum UserRolePermission {
  // Trader basic
  VIEW_TRADER_BASIC = 'view_trader_basic',
  VIEW_TRADER_SENSITIVE = 'view_trader_sensitive',
  EDIT_TRADER_PROFILE = 'edit_trader_profile',
  DELETE_TRADER = 'delete_trader',
  DISABLE_TRADER = 'disable_trader',
  FLAG_TRADER = 'flag_trader',

  // Account
  VIEW_ACCOUNT_BASIC = 'view_account_basic',
  VIEW_ACCOUNT_FULL = 'view_account_full',
  EDIT_ACCOUNT = 'edit_account',
  CLOSE_ACCOUNT = 'close_account',
  ASSIGN_ACCOUNT = 'assign_account',
  CREDIT_REFUND_ACCOUNT = 'credit_refund_account',

  // Paid
  VIEW_LEELOO_PAID = 'view_leeloo_paid',
  VIEW_TRADER_PAID = 'view_trader_paid',

  // Trading
  EDIT_TRADES_AS_COMPANY = 'edit_trades_as_company',

  // Notes
  ADD_NOTE = 'add_note',
  EDIT_OWN_NOTE = 'edit_own_note',
  EDIT_ANY_NOTE = 'edit_any_note',
  DELETE_NOTE = 'delete_note',

  // Purchase / Finance
  VIEW_PURCHASE_HISTORY = 'view_purchase_history',
  VIEW_RECEIPTS = 'view_receipts',
  VIEW_PAYOUTS = 'view_payouts',
  VIEW_REVENUE = 'view_revenue',

  // Payout actions
  APPROVE_PAYOUT = 'approve_payout',
  EXECUTE_PAYOUT = 'execute_payout',

  // Discounts / Packages
  CREATE_DISCOUNT_CODE = 'create_discount_code',
  ADD_PACKAGE = 'add_package',

  // Reports
  VIEW_REPORTS = 'view_reports',
  EXPORT_REPORTS = 'export_reports',

  // Marketing
  EDIT_EMAIL_TEMPLATES = 'edit_email_templates',

  // System
  MANAGE_USERS = 'manage_users',
  MANAGE_ROLES = 'manage_roles',
  MANAGE_SYSTEM_SETTINGS = 'manage_system_settings',

  // Pending Eval
  APPROVE_EVAL = 'approve_eval',
  DENY_EVAL = 'deny_eval',
  BLOCK_EVAL = 'block_eval',
}

export type UserRes = {
  current_page: number;
  emails: EmailReq[];
  has_next: boolean;
  total: number;
  total_pages: number;
};
